import { render, staticRenderFns } from "./Numbercards.vue?vue&type=template&id=b8775e64"
var script = {}
import style0 from "./Numbercards.vue?vue&type=style&index=0&id=b8775e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports